import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp, {BLACK} from 'src/components/Stamp/Stamp';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
};

const DeadlinePassedText = ({showTooltipFlag = false}) => {
  const infoText = 'Deadline to earn has passed';
  if (!showTooltipFlag) {
    return (
      <Stamp>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={BLACK} className="flag">
            <Icon iconType="flag" color="grey" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};
DeadlinePassedText.propTypes = propTypes;
export default DeadlinePassedText;
